import Notes from '@/pages/Notes';
import ProtectedRoute from '@/components/auth/ProtectedRoute';

export default function NotesPage() {
  return (
    <ProtectedRoute requiredRole="manager">
      <Notes />
    </ProtectedRoute>
  );
}